export type Layout = "horizontal" | "vertical";
export type TileWidth = "x-small" | "small" | "medium" | "large" | "x-large" | "xx-large";

/** Utility class for tiles and other controls in the tiles. */
export class TileUtilities {
  public static getColumnsWidth(width: TileWidth): string {
    width = width ? (width.toLowerCase() as TileWidth) : "xx-large";
    switch (width) {
      case "x-small":
        return "col-3";
      case "small":
        return "col-4";
      case "medium":
        return "col-6";
      case "large":
        return "col-8";
      case "x-large":
        return "col-9";
      case "xx-large":
        return "col-12";
      default:
        return "col-12";
    }
  }
}

export class TileRefreshStatus {
  public refreshFailed: boolean;
  public lastRefreshDate: Date;

  constructor(public isViewAll?: boolean, public isDrillInView?: boolean, public isRefreshDisabled?: boolean) {}

  public setToFailed(): void {
    this.refreshFailed = true;
  }

  public setToSucceeded(): void {
    this.refreshFailed = false;
    this.lastRefreshDate = new Date();
  }
}

export class TileRefreshStatusFactory {
  constructor() {}
  createTileRefreshStatusObject(
    isViewAll?: boolean,
    isDrillInView?: boolean,
    isRefreshDisabled?: boolean
  ): TileRefreshStatus {
    return new TileRefreshStatus(isViewAll, isDrillInView, isRefreshDisabled);
  }
}
